/* Frontend status keys */
export const CREATED = 'CREATED'
export const PROCESSING = 'PROCESSING'
export const TRANSFERRED = 'TRANSFERRED' // secondary status
export const SCHEDULED = 'SCHEDULED' // secondary status
export const RELEASED = 'RELEASED' // secondary status
export const SHIPPED = 'DISPATCHED'
export const IN_TRANSIT = 'IN_TRANSIT'
export const DELIVERED = 'DELIVERED'
export const CANCELLED = 'CANCELLED'

export const RETURN_REQUESTED = 'RETURN_REQUESTED'
export const RETURN_INTRANSIT = 'RETURN_IN_TRANSIT'
export const RETURN_PROCESSING = 'RETURN_PROCESSING'
export const RETURN_RECEIVED = 'RETURN_RECEIVED' // secondary status
export const RETURN_ACCEPTED = 'RETURN_ACCEPTED' // secondary status
export const PARTIALLY_RETURN_ACCEPTED = 'PARTIALLY_RETURN_ACCEPTED' // secondary status
export const RETURN_REFUNDED = 'RETURN_REFUNDED'
export const RETURN_PARTIALLY_REFUNDED = 'RETURN_PARTIALLY_REFUNDED'
export const RETURN_REFUSED = 'RETURN_REFUSED'

export const EXCHANGED = 'EXCHANGED'
export const EXCHANGE_ACCEPTED = 'EXCHANGE_ACCEPTED'

/* OMS status */
export const OMS_CREATED = 'Created'
export const OMS_AWAITING_PROCUREMENT_CREATION = 'Awaiting Procurement Transfer Order Creation'
export const OMS_PARTIALLY_AWAITING_PROCUREMENT_CREATION = 'Partially Awaiting Procurement Transfer Order Creation'
export const OMS_PROCUREMENT_CREATED = 'Procurement Transfer Order Created'
export const OMS_PARTIALLY_PROCUREMENT_CREATED = 'Partially Procurement Transfer Order Created'
export const OMS_SCHEDULED = 'Scheduled'
export const OMS_PARTIALLY_SHEDULED = 'Partially Scheduled'
export const OMS_UNSCHEDULED = 'Unscheduled'
export const OMS_BACKORDERED = 'Backordered'
export const OMS_ORDER_BEING_PACKED = 'Order Being Packed'
export const OMS_RELEASED = 'Released'
export const OMS_SHIPPED = 'Shipped'
export const OMS_SHIPPED_INVOICED = 'Shipped and Invoiced'
export const OMS_CANCELLED = 'Cancelled'
export const OMS_INCLUDED = 'Included In Shipment'
export const OMS_PARTIALLY_INCLUDED = 'Partially Included In Shipment'
export const OMS_PARTIALLY_RELEASED = 'Partially Released'
export const OMS_PARTIALLY_SHIPPED = 'Partially Shipped'
export const OMS_PARTIALLY_SHIPPED_INVOICED = 'Partially Shipped and Invoiced'
export const OMS_PARTIALLY_ORDER_BEING_PACKED = 'Partially Order Being Packed'

export const OMS_RETURN_FORM_CREATED = 'Return Form Created'
export const OMS_PARTIALLY_RETURN_FORM_CREATED = 'Partially Return Form Created'
export const OMS_RETURN_ACCEPTED = 'Return Accepted'
export const OMS_PARTIALLY_RETURN_ACCEPTED = 'Partially Return Accepted'
export const OMS_RETURN_REFUNDED = 'Return Refunded'
export const OMS_PARTIALLY_RETURN_REFUNDED = 'Partially Return Refunded'
export const OMS_RETURN_REFUSED = 'Return Refused'
export const OMS_PARTIALLY_RETURN_REFUSED = 'Partially Return Refused'
export const OMS_RETURN_RESHIPPED = 'Return Reshipped'
export const OMS_PARTIALLY_RETURN_RESHIPPED = 'Partially Return Reshipped'
export const OMS_RETURN_CANCELLED = 'Return Cancelled'

export const OMS_EXCHANGED = 'Exchanged'
export const OMS_PARTIALLY_EXCHANGED = 'Partially Exchanged'
export const OMS_EXCHANGE_ACCEPTED = 'Accepted for Exchange'
export const OMS_PARTIALLY_EXCHANGE_ACCEPTED = 'Partially Accepted for Exchange'
